<template>
  <div class="indexbody">
    <el-main class="main-right">
      <home-center></home-center>
    </el-main>
  </div>
</template>
<script>
import HomeCenter from "@/components/Home/Center.vue";

export default {
  components: {
    HomeCenter,
  },
  data() {
    return {};
  },
  destroyed: function () {},
  mounted() {},
  methods: {},
};
</script>
<style>
.head-nav .head-nav-left {
  line-height: 50px;
  padding-left: 10px;
  font-size: 16px;
  color: #555;
}
</style>


// WEBPACK FOOTER //
// src/components/Home/Index.vue